import { api } from 'api'
import { useMutation } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useUpdateEkeng = () => {
  return useMutation({
    mutationFn: (id) => {
      return api.users.updateEkeng(id)
    },
    onError: (err: any) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при обновлении ekeng',
        description: err.response?.data?.message || err.message,
      })
    }
  })
}
